import dayjs from "dayjs";
import duration from "dayjs/plugin/duration";

dayjs.extend(duration);

import { createApp } from "vue";
import PortalVue from "portal-vue";
import VCalendar from "v-calendar";
import VueViewer from "v-viewer";
import router from "./router";
import store from "./store";
import App from "./App.vue";

import "swiper/css";
import "v-calendar/dist/style.css";
import "viewerjs/dist/viewer.css";
import "../src/assets/css/main.css";
import "../src/assets/css/general.css";
import "../src/assets/css/attendance.css";
import "../src/assets/images/common/general.css";
import "@/assets/css/custom.css";

const app = createApp(App);

app.use(PortalVue);
app.use(store);
app.use(router);
app.use(VCalendar, {});
app.use(VueViewer);
app.mount("#app");
